// The Dashboard shell (Brief 4 / P8) — the visible spine of the product, and
// the rename off the retired "fleet" surface. A Discord-style two-pane layout:
// the persistent left sidebar (the Global room + your projects) and the content
// pane the left→right descent renders into (home → a project's sessions → a
// session's operators + live tail). Token-pure; the one reserved attention
// signal belongs to needs-me in the sidebar, never the chrome.

import { Outlet } from "react-router-dom";
import { Sidebar } from "../dashboard/sidebar/Sidebar";
import { TopBar } from "./TopBar";
import "../dashboard/dashboard.css";

export function DashboardShell() {
  return (
    <div className="wt-dash">
      {/* The brand's newsprint grain over the whole app (quiet — see --rcpt-grain
          -opacity on .wt-dash); aria-hidden, pointer-events-none. */}
      <div className="wt-receipt-grain" aria-hidden />
      <Sidebar />
      <main className="wt-dash__content">
        {/* Top-right chrome: appearance + account, icon-only. Sticky over the
            content pane, click-through except for its controls. */}
        <TopBar />
        <Outlet />
      </main>
    </div>
  );
}
